<template>
    <el-container>
        <el-header style="padding: 0; min-height: 30px;">
            <el-page-header @back="goBack" content="分配课程"></el-page-header>
        </el-header>
        <el-dialog
            :title="courseDialog.title"
            :visible.sync="courseDialog.show"
            width="60%"
            :close-on-click-modal=false
            :before-close="courseClose"
            top="10vh"
        >
            <el-form ref="courseForm" :model="courseDialog.searchData" label-width="80px">
                <el-row>
                    <el-col :span="7">
                        <el-form-item label="组织机构" prop="orgCode">
                            <el-select
                                placeholder="组织机构"
                                clearable
                                size="small"
                                v-model="courseDialog.searchData.orgCode"
                                style="margin-right: 10px; "
                                @change="changeCourseOrgCode"
                            >
                                <el-option
                                    v-for="o in org"
                                    :label="o.organizationName"
                                    :value="o.orgCode"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <el-form-item label="课程分类:" :inline="true" prop="courseType">
                            <el-cascader
                                expand-trigger="hover"
                                :options="courseDialog.courseTypeOptions"
                                style
                                clearable
                                :props="{ value: 'courseTypeId', label: 'courseTypeName',children: 'childNodeLst'}"
                                v-model="courseDialog.selectedCourseType"
                                @change="changeCourseType"
                            ></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="课程名称" prop="name">
                            <el-input
                                v-model="courseDialog.searchData.name"
                                placeholder="课程名称"
                                size="small"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-button
                            style="margin-left:20px;"
                            type="primary"
                            icon="el-icon-search"
                            @click="searchCourse()"
                        >搜索</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <el-table
                :data="courseDialog.dataList"
                border
                ref="multipleTable"
                highlight-current-row
                v-loading="courseDialog.loading"
                style="width: 100%; margin-bottom: 20px;"
                @selection-change="handleCourseSelectChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="课程名称" fixed="left"></el-table-column>
            </el-table>
             <el-pagination
                background
                layout="prev, pager, next"
                :total="courseDialog.total"
                :page-size="courseDialog.pageSize"
                :current-page.sync="courseDialog.currentPage"
                @size-change="handleCourseSizeChange"
                @current-change="handleCourseCurrentChange"
                style="margin-top: -5px; float: right; margin-right: 10px"
            ></el-pagination>
            <el-form style="clear:both;">
                <el-form-item>
                    <el-button
                        type="success"
                        size="small"
                        icon="el-icon-search"
                        @click="courseCancel()"
                    >取消</el-button>
                    <el-button
                        type="success"
                        size="small"
                        icon="el-icon-search"
                        @click="courseSave()"
                    >确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-main>
            <el-form ref="formData" :model="formData" label-width="100px">                
                <el-form-item label="分配课程：" prop="courseList">
                    <el-button
                        type="success"
                        icon="el-icon-circle-plus-outline"
                        size="small"
                        round
                        @click="courseOpen"
                        class="but-cls"
                    >选择课程</el-button>
                    <el-tag
                        v-for="course in courseTag"
                        :key="course.courseId"
                        :disable-transitions="true"
                        @close="handleCloseCourseTag(course)"
                        closable
                        style="margin-left:10px"
                    >{{course.name}}</el-tag>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        plain
                        size="small"
                        icon="el-icon-search"
                        @click="onSubmit()"
                    >确定</el-button>
                </el-form-item>
            </el-form>
        </el-main>
    </el-container>
</template>

<script>
import https from "@/https.js";
import validate from "@/api/validate.js";

const courseForm = {
    orgCode: "",
    courseTypeList: [],
};

export default {
    data() {
        return {
            loading:false,
            orgCode: "eblcu",
            orgType:"",
            org: [],
            orgBanchList: [],
            title: "选择课程",
            //region 课程弹框
            courseDialog: {
                show: false,
                searchData: {
                    orgCode: "",
                    courseTypeList: [],
                    name: "",
                },
                selectedOrgData: {},
                loading: false,
                dataList: [],
                total: 0,
                pageSize: 10,
                currentPage: 1,
                //课程分类
                courseTypeOptions: [],
                selectedCourseType: [],
                selectedCourse: [],
            },
            //endregion 课程

           formData: {
                orgCode: "",
                courseList: [],
                studentList: [],
            },
            courseTag: [],
        };
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
        selectOrg() {
            https
                .fetchGet("/managerOrganization/getOrganizationList", "", "from")
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.org = data.data.data;
                    } else {
                        this.$message({
                            type: "info",
                            message: msg,
                        });
                    }
                })
                .catch((err) => {
                    this.$message.error("网络错误");
                });
        },       
        //region 课程
        courseOpen() {
            this.courseDialog.show = true;
            this.courseDialog.courseTypeOptions = [];
            this.courseDialog.selectedCourseType = [];
            this.courseDialog.searchData = JSON.parse(JSON.stringify(courseForm));
            this.courseDialog.dataList = [];
        },
        courseClose() {
            this.courseDialog.show = false;
            this.courseDialog.searchData = JSON.parse(JSON.stringify(courseForm));
        },
        courseCancel() {
            this.courseDialog.show = false;
        },
        courseSave() {
            if (this.courseDialog.selectedCourse.length < 1) {
                this.$message.error("请选择课程");
                return;
            }
            console.log(this.courseDialog.selectedCourse);
            for (var item of this.courseDialog.selectedCourse) {
                console.log(item);
                let isExt = this.courseTag.findIndex(function (t) {
                    return t.courseId == item.courseId;
                });

                if (isExt < 0) {
                    this.courseTag.push(item);
                }
            }

            this.courseDialog.show = false;
        },
        //选择课程
        handleCourseSelectChange(val) {
            console.log(val);
            this.courseDialog.selectedCourse = [];
            for (let index in val) {
                let course = {
                    courseId: val[index].courseId,
                    name: val[index].name,
                };
                this.courseDialog.selectedCourse.push(course);
            }
        },
        handleCourseSizeChange() {},
        handleCourseCurrentChange(val) {
            this.searchCourse(val);            
        },
         //获取课程类目
        searchCourseType(val) {
            let params = {
                orgCode: this.courseDialog.searchData.orgCode,
            };
            this.courseDialog.courseTypeOptions = [];
            this.https
                .fetchPost("/courseType/courseTypeOfCourseCheck", params, "json")
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.courseDialog.courseTypeOptions = data.data.data.childNodeLst;
                    } else {
                        // this.$message({
                        //     type: "info",
                        //     message: "加载失败:" + msg,
                        // });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message.error("网络错误");
                });
        },
        //更改机构
        changeCourseOrgCode(val) {
            if (!val) {
                this.courseDialog.courseTypeOptions = [];
                return;
            }
            this.courseDialog.selectedOrgData = val;
            this.searchCourseType();
        },
        //更改课程分类
        changeCourseType(val) {
            console.log(val);
            if (val.length > 0) {
                //this.searchCourse(val);
            }
        },
        //查询课程
        searchCourse(val) {
            console.log("val的值"+val);
            if (val) {
                this.courseDialog.currentPage = val;
            } else {
                this.courseDialog.currentPage = 1;
            }

            let selectedCourseType = this.courseDialog.selectedCourseType;
            console.log(selectedCourseType);
            let params = {
                orgCode: this.courseDialog.searchData.orgCode,
                name: this.courseDialog.searchData.name,
                page: this.courseDialog.currentPage,
                limit: this.courseDialog.pageSize,
            };
            if (selectedCourseType && selectedCourseType.length > 0) {
                switch (selectedCourseType.length) {
                    case 1:
                        params.categoryOne = selectedCourseType[selectedCourseType.length - 1];
                        break;
                    case 2:
                        params.categoryTwo = selectedCourseType[selectedCourseType.length - 1];
                        break;
                    case 3:
                        params.categoryThree = selectedCourseType[selectedCourseType.length - 1];
                        break;
                }
            }

            this.courseDialog.loading = true;
            this.https
                .fetchPost("/course/getCourseByType", params, "json")
                .then((data) => {
                    this.courseDialog.loading = false;
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == 200) {
                        this.courseDialog.dataList = data.data.data;
                        this.courseDialog.total = data.data.total;
                    } else {
                        this.$message({
                            type: "info",
                            message: "加载失败:" + msg,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.courseDialog.loading = false;
                    this.$message.error("网络错误");
                });
        },
        handleCloseCourseTag(tag) {
            this.courseTag.splice(this.courseTag.indexOf(tag), 1);
        },
        //endregion 课程

        //提交
        onSubmit() {
            let courseTag = this.courseTag;
         
            if (courseTag.length < 1) {
                this.$message.error("请选择分配课程");
                return;
            }
           
            let courseIdList = courseTag.map(function (course) {
                return course.courseId;
            });
           
            let params = {
                courseIdList: courseIdList,
                userName: this.formData.userName
            };
            this.https
                .fetchPost("/managerStudent/updateStudentCourse", JSON.parse(JSON.stringify(params)), "json")
                .then((data) => {
                    let code = data.data.code;
                    let msg = data.data.msg;
                    if (code == "200") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                        });
                        this.goBack();
                    } else {
                        this.$message.error("操作失败:" + msg);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.$message.error("数据加载失败");
                });
        },
    },
    created: function () {
        this.orgType = this.$store.state.orgType;
        let userModel =this.$route.params.userModel;
        console.log(userModel);
       
        //已分配的课列表courseTag
        if(userModel){
             this.formData.userName = userModel.userName;
            if(userModel.courseList && userModel.courseList.length>0){
                for(var i=0,len = userModel.courseList.length;i<len;i++){
                    let item = userModel.courseList[i];
                    let model={
                        courseId:item.courseId,
                        name:item.courseName
                    };
                    this.courseTag.push(model);
                }
            }
        }
        this.selectOrg();
    },
};
</script>